import { ConfigType } from './index.d';

const IS_I18N = process.env.IS_I18N === 'true';
const appName = IS_I18N? 'VooV Meeting': '腾讯会议';

const config: ConfigType = {
  APP_NAME: appName,
  SCHEME_URL: {
    INMEETING: 'wemeet://page/inmeeting',
    LAUNCH: 'wemeet://launch',
    SCHEME_AUTH_SSO: 'wemeet://auth/sso',
  },
};

export default config;
